import { init } from "@instantdb/react";
import schema from "../../instant.schema.ts";
import { instantAppId } from "../../constants.ts";
import { coerce } from "@uri/gamla";
import { signal } from "@preact/signals";

export const { useAuth, transact, tx, auth, queryOnce, useQuery } = init({
  appId: instantAppId,
  schema,
});

export const userIdDeFacto = signal<string | null>(null);

export const userIdNotAuth = () => coerce(userIdDeFacto.value);
